'use client';
import { useRef, useEffect } from "react";

const BlogBannerInteractive = () => {
    const interactiveRef = useRef(null);
    let curX = 0;
    let curY = 0;
    let tgX = 0;
    let tgY = 0;

    useEffect(() => {
        const $interactive = interactiveRef.current;

        if (!$interactive) return;

        const move = () => {
            curX += (tgX - curX) / 20;
            curY += (tgY - curY) / 20;

            $interactive.style.setProperty(
                "transform",
                `translate(${Math.round(curX)}px, ${Math.round(curY)}px)`
            );

            requestAnimationFrame(move);
        };

        const handleMouseMove = (event) => {
            const offset = 200;
            tgX = event.clientX - offset;
            tgY = event.clientY - offset;
        };

        window.addEventListener("mousemove", handleMouseMove);
        move();

        return () => {
            window.removeEventListener("mousemove", handleMouseMove);
        };
    }, []);

    return (
        <div ref={interactiveRef} className="interactive"></div>
    );
};

export default BlogBannerInteractive;
